import { Component, Input } from '@angular/core';

@Component({
    selector: 'mh-core-lib-loader-wrapper',
    templateUrl: './loader-wrapper.component.html',
    styleUrls: ['./loader-wrapper.component.scss'],
    standalone: false
})
export class CoreLibLoaderWrapperComponent {
  @Input()
  loading = false;

  @Input()
  type: 'graphFollowupOnsite' | 'collect' | 'invertedT' | 'generic' | 'genericOneLine' | 'spinner' | 'overlaySpinner' = 'generic';

  @Input()
  className = '';

  @Input()
  spinnerClassName = '';
}
